import { APP_IDS, type AppId } from '@omnia/shared';
import { tr } from '../lib/i18n.ts';
import { APPS } from './registry.ts';
import { useDesktop } from './store.ts';
import { AppTile } from './AppTile.tsx';

export function Dock() {
  const windows = useDesktop((s) => s.windows);
  const focused = useDesktop((s) => s.focused);

  function activate(id: AppId) {
    const { open, minimize } = useDesktop.getState();
    // Clicking the focused app's tile tucks it away, matching platform docks.
    if (focused === id && windows[id] && !windows[id].minimized) minimize(id);
    else open(id);
  }

  return (
    <nav className="dock" aria-label={tr.dock.label}>
      <ul>
        {APP_IDS.map((id) => {
          const running = Boolean(windows[id]);
          return (
            <li key={id}>
              <button
                type="button"
                className="dock-item"
                data-running={running || undefined}
                data-focused={focused === id || undefined}
                aria-label={running ? `${APPS[id].title}, ${tr.dock.running}` : APPS[id].title}
                onClick={() => activate(id)}
              >
                <AppTile id={id} size={44} />
                <span className="dock-tooltip" aria-hidden>
                  {APPS[id].title}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
